module.exports = __webpack_public_path__ + "media/application/images/ui/badge-trusted-with-text-small-93a4e73bba7cd5f801f5568d4d6c05be.png";